export default {
  data: function data() {
    return {
      app: document.querySelector('#app')
    };
  },
  mounted: function mounted() {
    this.resize();
  },
  beforeMount: function beforeMount() {
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  method: {
    resize: function resize() {}
  },
  watch: {
    // 监听路由变化
    $route: function $route(to, from) {
      this.resize();
    }
  }
};